import type { FunctionComponent } from 'react'

import { useBudgetModule } from '../../useBudgetModule'
import { budgetEstimatesCalculatorService } from './budgetEstimatesCalculatorService'
import { DisposableAmountSection } from './DisposableAmountSection'
import { EstimateSection } from './EstimateSection'
import { OverviewSection } from './OverviewSection'

export const BudgetOverview: FunctionComponent<{
	children?: never
	historicalAverage: boolean
}> = ({ historicalAverage }) => {
	const budgetEstimates = budgetEstimatesCalculatorService.getEstimates()
	const { config } = useBudgetModule()

	if (budgetEstimates == null) return null
	return (
		<div>
			{budgetEstimates.tree.income != null ? (
				<OverviewSection
					itemKey="incomeTotal"
					total={budgetEstimates.tree.income.total}
					branch="tree.income"
				>
					<EstimateSection
						record={budgetEstimates.tree.income}
						branch="tree.income"
					/>
				</OverviewSection>
			) : null}
			{budgetEstimates.tree.expenses != null ? (
				<OverviewSection
					itemKey="expensesTotal"
					total={budgetEstimates.tree.expenses.total}
					branch="tree.expenses"
				>
					<EstimateSection
						record={budgetEstimates.tree.expenses}
						branch="tree.expenses"
					/>
				</OverviewSection>
			) : null}
			{!config.shouldHideDiscretionaryIncome &&
			!historicalAverage &&
			budgetEstimates.tree.expenses != null &&
			budgetEstimates.tree.income != null ? (
				<DisposableAmountSection
					totalDisposableAmount={
						budgetEstimates.tree.expenses.total +
						budgetEstimates.tree.income.total
					}
				/>
			) : null}
		</div>
	)
}
